import { Col, Collapse, Row, Table, Form, Radio, Spin, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import ViewNewPR from "./ViewNewPR";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select } from "antd";
import { getRequest } from "../../axios";

const { Option } = Select;
const { Panel } = Collapse;

const ViewRFQMaterialDetails = ({ RFQMaterialDetails1 }) => {
  const { t } = useTranslation();
  const { responseId } = useParams();
  const [totalWbsAmount, setTotalWbsAmount] = useState(null);
  const [siteIdAmount, setSiteIdAmount] = useState([]);
  const [RFQMaterialDetails, setRFQMaterialDetails] = useState([]);
  const [rfqNumber, setRfqNumber] = useState([]);
  const [rendomId, setRendomId] = useState("");
  const [stateWBS, setStateWBS] = useState([
    "Available Budget",
    "Estimated PR Value",
  ]);
  const [state, setState] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [prNumbers, setPrNumbers] = useState([]);
  const [view, setView] = useState(null);
  const [viewOption, setViewOption] = useState(false);
  const [type, setType] = useState("City Wise");
  const [am, setAm] = useState(0);
  const formRef = useRef();
  const [rfqMaterialDetailsID, setRfqMaterialDetailsID] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [uomList, setUOMList] = useState([]);
  const [materialDetails, setMaterialDetails] = useState([]);
  const [masterId, setMasterId] = useState(null);
  const [ifMultipleMasterId, setIfMultipleMasterId] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [uomLoading, setUomLoading] = useState(false);
  const [categoryTree, setCategoryTree] = useState("");


  useEffect(() => {
    fetchRFQMaterialDetails();
  }, []);

  useEffect(() => {
    setMaterialDetails(RFQMaterialDetails);
  }, [RFQMaterialDetails]);

  useEffect(() => {
    if (categoryId) {
      getUnitOfMeasurement();
    }
  }, [categoryId]);

  const fetchRFQMaterialDetails = async () => {
    setApiLoading(true);
    try {
      const response1 = RFQMaterialDetails1;
      setType("City Wise");

      if (formRef.current) {
        formRef.current.setFieldsValue({
          pr_view: "City Wise",
        });
      }

      const categoryTree = response1?.data?.data?.category_tree;
      setCategoryId(categoryTree || null);

      setRfqNumber(response1.data.data.rfq_number);
      setRFQMaterialDetails(response1.data.data);
      setCategoryTree(response1?.data?.data?.category_tree_name || "");
      const masterId = response1.data.data.rfq_details[0].id;
      if (masterId) {
        setMasterId(masterId);
      }
      setView("City Wise");

      if (response1.data.data.pr_matieral_details_by_pr_number !== null) {
        const siteIdAmountsByPr =
          response1?.data?.data?.pr_matieral_details_by_pr_number.reduce(
            (acc, item) => {
              const flattenedValues = item.estimated_pr_values.flat();
              const siteAmountMap = flattenedValues.reduce((map, site) => {
                if (!map[site.pr_site_id]) {
                  map[site.pr_site_id] = {
                    id: site.pr_site_id,
                    name: site.pr_site_name,
                    amount: site.pr_site_amount,
                  };
                } else {
                  map[site.pr_site_id].amount += site.pr_site_amount;
                }
                return map;
              }, {});
              acc[item.pr_number] = Object.values(siteAmountMap);
              return acc;
            },
            {}
          );
        setSiteIdAmount(siteIdAmountsByPr);
        const flattenedData = Object.values(siteIdAmountsByPr).flat();
        setTotalWbsAmount(
          flattenedData.reduce((sum, data) => sum + data.amount, 0)
        );
      }
      setRendomId(responseId);
      const prs = response1?.data?.data?.pr_number?.map((pr) => pr);
      setPrNumbers(prs);

      const initialState = {
        rfqId: response1.data.data.rfq_details[0].id,
        rfq_material_details: response1.data.data.material_wise_details.map(
          (material) => {
            return {
              id: material.rfq_material_id,
              material_total_quantity: material.material_total_quantity,
              material_total_quantity_by_kg:
                material.material_total_quantity_by_kg,
              amount: material.amount,
              purchase_requisition_material:
                material.purchase_requisition_material_id,
              purchase_requisition_material_type_name:
                material.purchase_requisition_material_type_name,
              unit_of_measurement: material.unit_of_measurement,
              purchase_requisition_material_type_idd:
                material.purchase_requisition_material_type_id,
            };
          }
        ),
      };
      setState(initialState);

      const rfqMaterialDetails = response1?.data?.data?.rfq_material_details;

      if (
        Array.isArray(rfqMaterialDetails) &&
        rfqMaterialDetails.length === 0
      ) {
        setRfqMaterialDetailsID(false);
      } else {
        setRfqMaterialDetailsID(true);
      }
      setTotalWbsAmount(response1.data.data.rfq_total_amount);

      setApiLoading(false);
    } catch (error) {
      console.error("Error in fetchRFQMaterialDetails:", error);
      setApiLoading(false);
    }
  };

  const getUnitOfMeasurement = async () => {
    setUomLoading(true);
    try {
      if (!categoryId) {
        console.warn("categoryId is null, skipping getUnitOfMeasurement");

        setUomLoading(false);
        return;
      }
      const response = await getRequest(
        `get-category-by-uom/?category_tree=${categoryId}`
      );
      const resultsData = response?.data?.results?.data || response?.data?.data || response?.data || [];
      const filteredData = Array.isArray(resultsData)
        ? resultsData.filter((item) => item.unit_of_measurement !== "KG")
        : [];
      if (!filteredData.length) {
        // console.warn("No valid UOMs after filtering, using fallback");
        // setUOMList([
        //   { id: 1, unit_of_measurement: "MT" },
        //   { id: 2, unit_of_measurement: "Bag" },
        //   { id: 3, unit_of_measurement: "Cum." },
        //   { id: 4, unit_of_measurement: "Cubic Meter" },
        // ]);
      } else {
        setUOMList(filteredData);
      }
    } catch (error) {
      console.error("Error in getUnitOfMeasurement:", error);
    } finally {
      setUomLoading(false);
    }
  };

  const renderTables = () => {
    if (!materialDetails) return null;

    const aggregatedData = {};
    const allSiteNames = new Set();
    const uniqueMasterIds = new Set();
    materialDetails?.material_wise_details?.forEach((material) => {
      uniqueMasterIds.add(material.purchase_requisition_master_id);
    });

    const hasMultipleMasterIds = uniqueMasterIds.size > 1;

    let previousMaterialId = null;
    materialDetails?.material_wise_details?.forEach((material, matIND) => {
      const subCategory =
        material.purchase_requisition_material_type_sub_category;
      const key = `${subCategory}-${material.purchase_requisition_material_type_name}`;

      if (!aggregatedData[subCategory]) {
        aggregatedData[subCategory] = {};
      }

      if (!aggregatedData[subCategory][key]) {
        aggregatedData[subCategory][key] = {
          purchase_requisition_material_type_name:
            material.purchase_requisition_material_type_name,
          totalQuantity: 0,
          totalAmount: 0,
          siteWiseQuantities: {},
          totalQuantityInKG: 0,
          unitOfMeasurement:
            material.unit_of_measurement_name ||
            material.preferred_unit_of_measurement,
          pref_uom: material.preferred_unit_of_measurement,
          uniqueMasterIds: uniqueMasterIds,
          rfq_material_id: material.rfq_material_id,
        };
      }

      if (material.material_total_quantity_by_kg) {
        aggregatedData[subCategory][key].totalQuantityInKG +=
          material.material_total_quantity_by_kg;
      }
      const op = material.purchase_requisition_master_id === previousMaterialId;

      material.site_wise.forEach((site) => {
        const currentUoM = material.unit_of_measurement_name;
        const preferredUoM = material.preferred_unit_of_measurement;
        const siteQuantity = site.site_wise_total_quantity;

        let adjustedQuantity = siteQuantity;
        previousMaterialId = material.purchase_requisition_master_id;
        previousMaterialId = material.purchase_requisition_material_type_name;

        if (materialDetails.rfq_material_details.length === 0) {
          if (currentUoM !== preferredUoM) {
            if (currentUoM !== preferredUoM && !hasMultipleMasterIds) {
              adjustedQuantity = siteQuantity;
            } else if (currentUoM === "MT" && preferredUoM === "KG") {
              adjustedQuantity = siteQuantity * 1000;
            } else if (currentUoM === "Bag" && preferredUoM === "KG") {
              adjustedQuantity = siteQuantity * 50;
            } else if (currentUoM === "Bag" && preferredUoM === "MT") {
              adjustedQuantity = (siteQuantity * 50) / 1000;
            } else if (currentUoM === "KG" && preferredUoM === "MT") {
              adjustedQuantity = siteQuantity / 1000;
            } else {
              adjustedQuantity = siteQuantity;
            }
          }
        }

        if (
          !aggregatedData[subCategory][key].siteWiseQuantities[site.site_name]
        ) {
          aggregatedData[subCategory][key].siteWiseQuantities[site.site_name] =
            0;
        }
        aggregatedData[subCategory][key].siteWiseQuantities[site.site_name] +=
          adjustedQuantity;

        aggregatedData[subCategory][key].totalQuantity += adjustedQuantity;
        aggregatedData[subCategory][key].totalAmount +=
          site.site_wise_total_amount || 0;

        allSiteNames.add(site.site_name);
      });
    });

    const subCategoriesArray = Object.keys(aggregatedData);

    return (
      <>
        {subCategoriesArray.map((subCategory, index) => {
          const materialsInSubCategory = Object.values(
            aggregatedData[subCategory]
          );

          let customSubCategory = subCategory;

          if (subCategory === "SPECIAL CEMENT") {
            customSubCategory = "Special Cement";
          } else {
            customSubCategory = subCategory;
          }

          const columns = [
            {
              title: "Sr.",
              dataIndex: "sr_no",
              key: "sr_no",
              width: 80,
              render: (text, record, index) => `${index + 1}`,
            },
            {
              title: `${customSubCategory}`,
              dataIndex: "purchase_requisition_material_type_name",
              key: "purchase_requisition_material_type_name",
              width: 150,
            },
            ...Array.from(allSiteNames).map((siteName) => ({
              title: siteName,
              dataIndex: siteName,
              key: siteName,
              align: "right",
              width: 140,
              render: (text, record) => {
                const displayedQuantity =
                  record.siteWiseQuantities[siteName] || 0;

                return (
                  <div style={{ textAlign: "right" }}>
                    {displayedQuantity.toFixed(2)}
                  </div>
                );
              },
            })),
            {
              title: "Total Quantity",
              dataIndex: "totalQuantity",
              key: "totalQuantity",
              align: "right",
              width: 120,
              render: (text, record) => (
                <div style={{ textAlign: "right" }}>
                  {record.totalQuantity.toFixed(2)}
                </div>
              ),
            },
            {
              title: (
                <Tooltip
                  color="#094E8F"
                  placement="top"
                  title={
                    <span style={{ color: "#fff" }}>
                      Preferred Unit of measurement means Your company buys
                      material generally in this unit of measurement
                    </span>
                  }
                >
                  Preferred UoM.
                </Tooltip>
              ),
              width: 120,
              dataIndex: "unit_of_measurement",
              key: "unit_of_measurement",
              render: (text, record, rowIndex) => {
                if (uomLoading) {
                  return <Spin size="small" />;
                }
                if (!uomList.length) {
                  return <span>No UOMs available</span>;
                }

                let defaultValue = 1;
                let defaultOption = null;
                if (record.rfq_material_id !== null) {
                  defaultOption = uomList.find(
                    (option) =>
                      option.unit_of_measurement === record.unitOfMeasurement
                  );
                  defaultValue = defaultOption?.id || 1;
                } else if (
                  record.uniqueMasterIds.size >= 2 &&
                  materialDetails.rfq_material_details.length !== 0
                ) {
                  defaultOption = uomList.find(
                    (option) => option.unit_of_measurement === record.pref_uom
                  );
                  defaultValue = defaultOption?.id || 1;
                } else if (
                  record.uniqueMasterIds.size >= 2 &&
                  materialDetails.rfq_material_details.length === 0
                ) {
                  defaultOption = uomList.find(
                    (option) => option.unit_of_measurement === record.pref_uom
                  );
                  defaultValue = defaultOption?.id || 1;
                } else {
                  defaultOption = uomList.find(
                    (option) =>
                      option.unit_of_measurement === record.unitOfMeasurement
                  );
                  defaultValue = defaultOption?.id || 1;
                }

                const isCubicMeter = defaultOption?.unit_of_measurement === "Cubic Meter";

                return (
                  <div key={index}>
                    <Select
                      style={{ width: "90%" }}
                      defaultValue={defaultValue}
                      disabled={isCubicMeter}
                      suffixIcon={null}
                      open={false}
                      onChange={(value) => {
                        const selectedOption = uomList.find(
                          (option) => option.id === value
                        );
                        // Add onChange logic if needed
                      }}
                    >
                      {uomList.map((option) => (
                        <Option
                          key={option.id}
                          value={option.id}
                          style={{ paddingRight: "0px" }}
                        >
                          <span
                            style={{
                              color: "black",
                              fontSize: "11px",
                            }}
                          >
                            {option.id === 4
                              ? "Cu. Mtr."
                              : option.unit_of_measurement}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </div>
                );
              },
            },
            {
              title: "Qty. In Kg",
              dataIndex: "totalQuantityInKG",
              key: "totalQuantityInKG",
              align: "right",
              width: 100,
              render: (text, record) => (
                <div style={{ textAlign: "right" }}>
                  {record.totalQuantityInKG.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </div>
              ),
            },
            {
              title: "Est. Amount",
              dataIndex: "totalAmount",
              key: "totalAmount",
              align: "center",
              width: 150,
              render: (text, record) => (
                <div style={{ textAlign: "center" }}>
                  ₹{" "}
                  {record?.totalAmount?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </div>
              ),
            },
          ];

          const dataSource = materialsInSubCategory.map((data, index) => {
            return {
              key: index,
              purchase_requisition_material_type_name:
                data.purchase_requisition_material_type_name,
              totalQuantity: data.totalQuantity,
              totalAmount: data.totalAmount,
              unitOfMeasurement: data.unitOfMeasurement,
              pref_uom: data.pref_uom,
              siteWiseQuantities: data.siteWiseQuantities,
              totalQuantityInKG: data.totalQuantityInKG,
              uniqueMasterIds: data.uniqueMasterIds,
              rfq_material_id: data.rfq_material_id,
              ...Array.from(allSiteNames).reduce((acc, siteName) => {
                acc[siteName] = data.siteWiseQuantities[siteName] || 0;
                return acc;
              }, {}),
            };
          });

          return (
            <Collapse defaultActiveKey={[index]} className="scroll5" key={index}>
              <Panel header={<Table columns={columns} />} key={index}>
                <Table
                  columns={columns}
                  dataSource={dataSource}
                  pagination={false}
                />
              </Panel>
            </Collapse>
          );
        })}
      </>
    );
  };

  useEffect(() => {
    if (materialDetails) {
      const uniqueMasterIds = new Set(
        materialDetails?.material_wise_details?.map(
          (material) => material.purchase_requisition_master_id
        )
      );
      if (uniqueMasterIds.size > 0) {
        setIfMultipleMasterId(Array.from(uniqueMasterIds));
      }
    }
  }, [materialDetails]);

  const handleOptionChange = (e) => {
    const value = e.target.value;
    setView(value);
    setViewOption((prevState) => ({
      ...prevState,
      pr_view: value,
    }));
  };

  return (
    <Spin spinning={apiLoading}>
      <div>
        <Row>
          <Col className="TextFeild gutter-row">
            <Form ref={formRef}>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    className="radioitem"
                    name="pr_view"
                    initialValue={type}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Radio.Group
                      onChange={handleOptionChange}
                      value={type}
                      className="prviewlabel radio"
                      style={{ marginLeft: "0" }}
                    >
                      <Radio value="City Wise">City/Region Wise</Radio>
                      {
                        categoryTree.toLowerCase() !== "earthing" && (
                          <Radio value="Material Wise">Material wise</Radio>
                        ) 
                      }
                      
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        {view === "City Wise" && !uomLoading ? (
          <ViewNewPR response={RFQMaterialDetails} uomList={uomList} />
        ) : (
          renderTables()
        )}
      </div>
    </Spin>
  );
};

ViewRFQMaterialDetails.propTypes = {
  RFQMaterialDetails1: PropTypes.object.isRequired,
};

export default ViewRFQMaterialDetails;